import React from 'react';
import PageHelmet from '../Helper/PageHelmet';
import Footer from '../Helper/Footer';
import HeadSection from './HeadSection';
import ContentSection from './ContentSection';

const WhyDsider = () => {
    return (
        <>
            <PageHelmet pageTitle="Why Dsider" />
            <HeadSection />
            <ContentSection />
            <Footer />
        </>
    );
};

export default WhyDsider;